module.exports = __webpack_public_path__ + "media/images/img_service_1-deb644111f0e7684d92e2c6ce8090a1b.jpg";